import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';

export default function SiteStormLogs({ logTypeName, logs, hide, onPrint }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const dateHourFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
    const [isClosed, setIsClosed] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let noItems = logs?.length === 0 && (<div className="centeredMessage"><h5>No Storm Logs available.</h5></div>);

    let shownLogs = logs.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));
    let shownStartIndex = (pageSize * selectedPage) - pageSize;
    let shownEndIndex = (pageSize * selectedPage);

    let logListItems = !isClosed && logs && logs
        .map((log, index) => <tr className={index < shownStartIndex || index >= shownEndIndex ? "hidden" : ""} key={log.id}>
            <td className="tabular-nums">{log.startedAt && dateHourFormatter.format(new Date(log.startedAt))}</td>
            <td className="tabular-nums">{log.endedAt && dateHourFormatter.format(new Date(log.endedAt))}</td>
            <td>{log.rainFallTotal}</td>
            <td className="smallScreen">
                <div className="log">
                    {log.startedAt && (<div>
                        <span className="fieldDesc">Start:</span>
                        <span className="whitespace-nowrap">{log.startedAt && dateHourFormatter.format(new Date(log.startedAt))}</span>
                    </div>)}
                    {log.endedAt && (<div>
                        <span className="fieldDesc">End:</span>
                        <span className="whitespace-nowrap">{log.endedAt && dateHourFormatter.format(new Date(log.endedAt))}</span>
                    </div>)}
                    {log.rainFallTotal !== undefined && (<div>
                        <span className="fieldDesc">Rainfall Total:</span>
                        {log.rainFallTotal}
                    </div>)}
                </div>
            </td>
        </tr>);

    if (selectedPage > 1 && (pageSize * selectedPage) - logListItems.length > 0) {
        let emptyRows = Array.from(
            { length: (pageSize * selectedPage) - logListItems.length },
            (cv, i) => (<tr className="noBkg noPrint" key={`R${i}`}><td>&nbsp;</td></tr>));
        logListItems = logListItems.concat(emptyRows);
    }

    let printButton = (<button onClick={() => onPrint("Storm Logs", "#stormLogs")}>Print</button>);

    let logList = logListItems.length === 0 ? undefined : !isClosed &&
        (<>
            <table id="stormLogs" className="itemList">
                <thead>
                    <tr>
                        <th className="date">Start</th>
                        <th className="date">End</th>
                        <th>Rainfall Total</th>
                    </tr>
                </thead>
                <tbody>{logListItems}</tbody>
            </table>
            <Pagination itemCount={logs.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>
                {printButton}
            </Pagination>
        </>);

    //let selectLogType = onSelectLogType && (<span className="select" onClick={() => onSelectLogType()}><i className={logTypeSelected ? "dhicon-check-2" : "dhicon-check-empty"} /></span>);
    let selectLogType;

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    //let openClose = (<i className={`icon ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />);
    let openClose;

    
    let logTypeNameDescription = (<div className="text-drhPalette-primary text-xl font-bold pt-3 pb-1 flex justify-between">
        <span>{logTypeName}</span>
    </div>);

    let hideClass = hide && "hidden"

    return (
        <div className={`logTypeContainer stormLogsContainer ${hideClass}`}>
            {logTypeNameDescription}
            {logList}
            {noItems}
        </div>
    );
}